import { MEMBERS_AREA_V2 } from '@wix/app-definition-ids';
import type { EditorSDK } from '@wix/platform-editor-sdk';

import { MembersAreaContext } from '../../types/context';
import { shouldInstallMembersAreaV3 as shouldInstallMembersAreaV3ByExp } from '../../utils/experiments';
import { isApplicationReady as isV1Installed } from '../applicationState';
import { isApplicationInstalled } from '../wrappers/application';
import { getGlobalMembersAreaController } from '../wrappers/controllers';
import { isMemberSettingsPageInstalled } from '../wrappers/tpa';

const getIsMembersAreaV2Installed = async (editorSDK: EditorSDK) => {
  return isApplicationInstalled(editorSDK, MEMBERS_AREA_V2);
};

const getIsMembersAreaV3Installed = async (editorSDK: EditorSDK) => {
  return isMemberSettingsPageInstalled(editorSDK);
};

const getShouldInstallMembersAreaV3 = async (editorSDK: EditorSDK) => {
  const shouldInstallMAV3ByExp = await shouldInstallMembersAreaV3ByExp();
  return shouldInstallMAV3ByExp || editorSDK.info.isBuilderComponentModelSupported('');
};

const getMemberAreaContextFromInstalledApps = async (editorSDK: EditorSDK) => {
  const [isMembersAreaV1Installed, isMembersAreaV2Installed, isMembersAreaV3Installed] = await Promise.all([
    await isV1Installed(editorSDK),
    await getIsMembersAreaV2Installed(editorSDK),
    await getIsMembersAreaV3Installed(editorSDK),
  ]);

  if (isMembersAreaV1Installed) {
    return MembersAreaContext.V1;
  } else if (isMembersAreaV3Installed) {
    return MembersAreaContext.V3;
  } else if (isMembersAreaV2Installed) {
    return MembersAreaContext.V2;
  }

  const isMembersAreaV3Enabled = await getShouldInstallMembersAreaV3(editorSDK);
  return isMembersAreaV3Enabled ? MembersAreaContext.V3 : MembersAreaContext.V2;
};

export const getMembersAreaContext = async (editorSDK: EditorSDK) => {
  return getMemberAreaContextFromInstalledApps(editorSDK);
};

export const getIsMembersAreaSeoEnabled = async (editorSDK: EditorSDK) => {
  try {
    const controllerConfig = await getGlobalMembersAreaController(editorSDK);

    return !!controllerConfig?.isMembersAreaSeoEnabled;
  } catch (e) {
    return false;
  }
};
